import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ALERT_ACTION_DENIED } from '@common/constants/alert.constant';
import { ROUTE_AUTH, ROUTE_LOGIN } from '@core/config/route-paths.config';
import { AlertService } from '@core/services/alert.service';
import { SessionService } from '@core/services/session.service';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<Request>,
    next: HttpHandler,
  ): Observable<HttpEvent<Event>> {
    const sessionService = inject(SessionService);
    const alertService = inject(AlertService);
    const router = inject(Router);

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          sessionService.removeSession();
          router.navigate([`/${ROUTE_AUTH}/${ROUTE_LOGIN}`]);
        }

        if (err.status === 403) {
          alertService.error(err.error.message);
          return EMPTY;
        }

        const error = err.error.message || err.statusText;
        return throwError(error);
      }),
    );
  }
}
